/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './contentVisibilityDeclaration.defs'
export { main as default } from './contentVisibilityDeclaration.defs'
